import { getFormDataFromObject } from '@cvt/helpers/form';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';

export const mapCreditData = (data: Credit.CreditApi): Credit.Credit => {
  return camelizeObject<Credit.Credit>(data);
};

export const mapCreditEditData = (data: Credit.Edit): FormData => {
  const apiData: Credit.EditApi = snakizeObject(data);
  
  const formData = getFormDataFromObject(apiData);
  
  return formData;
};